import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "830f94c0-d815-47d9-8190-a8b1388b612c",
    content: "200 Hz",
    options: {},
  },
  {
    id: "b08fbcfe-bbac-407e-8d8e-f2481a6a13d1",
    content: "100 Hz",
    options: {},
  },
  {
    id: "dca32458-167c-4f2a-9ac4-f42fb72ebfd5",
    content: "20 Hz",
    options: {},
  },
  {
    id: "b0e3669c-548d-4393-a696-38bb69ef3fe2",
    content: "1000 Hz",
    options: {},
  },
];

export const task: Task = {
  id: "643a96d3-45d5-4a96-9a38-c5117f5a626d",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["b08fbcfe-bbac-407e-8d8e-f2481a6a13d1"],
};
